var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-home" },
    [
      _c("granary-title"),
      _vm.showViewer
        ? _c("el-image-viewer", {
            attrs: {
              "initial-index": 0,
              "on-close": _vm.onClose,
              "url-list": _vm.urlList,
            },
          })
        : _vm._e(),
      _c("router-view"),
      _vm.hasmap ? _c("map-content") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }